import React, { useState } from "react";
import styles from "./Carousel.module.css";

const Carousel = ({ addresses, selectedAddressId, onSelect }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleSlides = 2;

  const nextSlide = () => {
    if (currentIndex < addresses.length - visibleSlides) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className={styles.carouselContainer}>
      <button
        className={styles.navButton}
        onClick={prevSlide}
        disabled={currentIndex === 0}
      >
        ◀
      </button>

      <div className={styles.carousel}>
        {addresses
          .slice(currentIndex, currentIndex + visibleSlides)
          .map((address) => (
            <div
              key={address.address_id}
              className={`${styles.addressCard} ${
                selectedAddressId === address.address_id ? styles.selected : ""
              }`}
              onClick={() => onSelect(address.address_id)}
            >
              <p className={styles.addressLine}>{address.address_line}</p>
              <p className={styles.area}>{address.area}</p>
              <p className={styles.location}>
                {address.city}, {address.state}
              </p>
              <p className={styles.pincode}>
                {address.country} - {address.pincode}
              </p>
              <p className={styles.addressType}>{address.address_type}</p>
              {address.is_default === 1 && (
                <span className={styles.defaultBadge}>Default</span>
              )}
            </div>
          ))}
      </div>

      <button
        className={styles.navButton}
        onClick={nextSlide}
        disabled={currentIndex >= addresses.length - visibleSlides}
      >
        ▶
      </button>
    </div>
  );
};

export default Carousel;
